import React, { ReactElement, useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown, { DropDownOptions } from 'components/@common/Inputs/Dropdown';
import PrintModal from 'components/ClassroomsModule/Classrooms/components/PrintModal';
import useParseActionRouteParams from 'hooks/route-action/use-parse-action-route-params';
import { Certificates } from 'types/enums';
import { buildSearchQueryParams } from 'utilities/query-params-util';

const PrintCertificatesCardsModal = (): ReactElement | null => {
  const { t } = useTranslation('PrintCertificatesCardsModal');
  const { studentId } = useParseActionRouteParams<{ studentId: string }>();
  const [selected, setSelected] = useState('');

  const certificatesOptions = [
    { label: 'Keyboarding Without Tears Completion Certificate', value: Certificates.KWT },
    { label: 'Digital Citizenship Completion Certificate', value: Certificates.DC }
  ] as Array<DropDownOptions>;

  const handleChange = (evt: ChangeEvent<any>): void => {
    setSelected(evt.target?.value || '');
  };

  const handleOnPrint = (): void => {
    window.open(
      `/print-screen/certificates${buildSearchQueryParams({
        studentId: +studentId,
        certificateType: selected
      })}`
    );
  };

  return (
    <PrintModal
      title={t('Print Student Certificates')}
      onPrint={handleOnPrint}
      options={{ printText: t('Print Certificate'), disablePrintButton: !selected }}
    >
      <Dropdown
        id="print-certificates-cards"
        options={certificatesOptions}
        handleChange={handleChange}
        label={t('Select Certificate')}
        value={selected}
      />
    </PrintModal>
  );
};

export default PrintCertificatesCardsModal;
